import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";

const DeleteView = ({ idItem, onSearch }: DeleteProduct) => {
  const handleDeleteRecruitment = async () => {
    try {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const res = await repository.post(`/TblTuyenDung/delete`, idItem);

      if (res && res.success) {
        NotificationExtension.Success("Xóa thành công !");
        modals.closeAll();
        onSearch();
      } else {
        NotificationExtension.Fails("Xóa thất bại !");
        modals.closeAll();
      }
    } catch (error) {
      console.error("Lỗi khi xóa:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi xóa. Vui lòng thử lại!");
      modals.closeAll();
    }
  };

  return (
    <div>
      <Text size="24px">
        Bạn có chắc chắn muốn xóa{" "}
        {idItem.length > 1 ? "các hồ sơ tuyển dụng" : "hồ sơ tuyển dụng "} này?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="red"
          onClick={handleDeleteRecruitment}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: string[];
  onSearch: () => void;
};

export default DeleteView;
